import { getContext } from "svelte";

import type { ValueWritable } from "..";
import type { Setting } from ".";

export function searchContext() {
    return getContext("search") as ValueWritable<string>;
}

export function createFilter(filter: (search: string) => boolean) {
    const search = getContext("search") as ValueWritable<string>;

    return (node: HTMLElement) => {
        const unsubscribe = search.subscribe((value) => {
            if (!value) {
                node.removeAttribute("data-search");
                return;
            }

            if (filter(value)) {
                node.setAttribute("data-search", "excluded");
            } else {
                node.setAttribute("data-search", "included");
            }
        });

        return {
            destroy: unsubscribe
        }
    }
}

export function createFilterExclude() {
    const search = getContext("search") as ValueWritable<string>;

    return (node: HTMLElement) => {
        const unsubscribe = search.subscribe((value) => {
            if (!value) {
                node.removeAttribute("data-search");
                return;
            }

            node.setAttribute("data-search", "excluded");
        });

        return {
            destroy: unsubscribe
        }
    }
}

export function createSettingFilter(setting: Setting) {
    return createFilter((search) => filterSetting(search, setting));
}

export function createStringFilter(str: string) {
    return createFilter((search) => filterString(search, str));
}



export function filterSetting(search: string, setting: Setting) {
    const pre = setting.prefix?.toLowerCase();
    const suf = setting.suffix?.toLowerCase();
    const nam = setting.name.toLowerCase();
    const val = setting.value?.toString().toLowerCase();

    return ![pre, suf, nam, val].filter(v => v !== undefined).some((str) => str.includes(search));
}

export function filterString( search: string, str: string) {
    return !str.toLowerCase().includes(search);
}